.wrapper {
  --box-size: 1.25rem;
  --box-radius: 0.375rem;

  display: inline-flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
}

.size-sm {
  --box-size: 1rem;
  --box-radius: 0.25rem;
}
.size-md {
  --box-size: 1.25rem;
  --box-radius: 0.375rem;
}

.disabled {
  cursor: not-allowed;
}

/* Nudge the box onto the first text line when a label is present. */
.wrapper:has(.text) .control {
  margin-top: 0.125rem;
}

.control {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: var(--box-size);
  height: var(--box-size);
}

.input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: inherit;
}

.box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid var(--border);
  border-radius: var(--box-radius);
  background: var(--surface);
  color: var(--fg-on-solid);
  box-sizing: border-box;
  transition:
    background 150ms ease,
    border-color 150ms ease,
    box-shadow 150ms ease;
}

.input:hover:not(:disabled) + .box {
  border-color: var(--brand-solid);
  background: var(--brand-tint);
}

.input:checked + .box,
.input:indeterminate + .box {
  background: var(--brand-solid);
  border-color: var(--brand-solid);
}

.input:checked:hover:not(:disabled) + .box,
.input:indeterminate:hover:not(:disabled) + .box {
  background: var(--brand-solid-hover);
  border-color: var(--brand-solid-hover);
}

.input:focus-visible + .box {
  outline: 2px solid transparent;
  box-shadow: var(--focus-ring);
}

.input:disabled + .box {
  background: var(--surface-tertiary);
  border-color: var(--border);
}

.input:checked:disabled + .box,
.input:indeterminate:disabled + .box {
  background: var(--surface-tertiary);
  border-color: var(--border);
  color: var(--border);
}

/* ── Check / dash glyphs ── */
.check,
.dash {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-flex;
  width: 70%;
  height: 70%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.glyph {
  display: block;
  width: 100%;
  height: 100%;
}

.input:checked:not(:indeterminate) + .box .check {
  opacity: 1;
}
.input:indeterminate + .box .dash {
  opacity: 1;
}

/* Windows High Contrast — the checked state is colour-only, so map it to system colours. */
@media (forced-colors: active) {
  .box {
    forced-color-adjust: none;
    background: Canvas;
    border-color: CanvasText;
  }
  .input:checked + .box,
  .input:indeterminate + .box {
    background: Highlight;
    border-color: Highlight;
    color: HighlightText;
  }
  .input:disabled + .box {
    border-color: GrayText;
  }
}

/* ── Label ── */
.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.label {
  color: var(--text-secondary);
}
.supporting {
  color: var(--text-tertiary);
}
.disabled .label,
.disabled .supporting {
  color: var(--text-disabled);
}
